export default __webpack_public_path__ + "static/media/8.ae8fdb1e.png";